import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import AudiencesInfoSection from '../../AudiencesFields/AudiencesInfoSection'
import AudienceSelectionRadioBlocks from '../../AudiencesFields/AudienceSelectionRadioBlocks'
import Spoiler from '../../../../../components/Spoiler'
import AdvancedAudienceTargetingSection from './AdvancedAudienceTargetingSection'

import { useLoadFacebookAudiences } from '../hooks'
import { hasTouchedErrors } from '../../../../../helpers/errors'

import { audiencesLoadingSelector } from '../../../../../modules/selectors/audiences'
import { SHOW_COUNTRIES, SHOW_REGIONS } from '../../../GeolocationsFields/fields'

const advancedAudienceTargetingFormFields = [SHOW_COUNTRIES, SHOW_REGIONS]

const FacebookUploadCreativeAudienceFields = ({ formik }) => {
  const { t } = useTranslation()

  const audiencesIsLoading = useSelector(audiencesLoadingSelector)

  const formattedAudiences = useLoadFacebookAudiences()

  const { errors, touched } = formik

  const hasAdvancedAudienceTargetingError = hasTouchedErrors({
    formFields: advancedAudienceTargetingFormFields,
    errors,
    touched
  })

  return (
    <>
      <AudiencesInfoSection targetAudiencesText="Target one or more audiences" />
      <AudienceSelectionRadioBlocks
        formik={formik}
        audiencesIsLoading={audiencesIsLoading}
        formattedAudiences={formattedAudiences}
      />
      <Spoiler title={t('View more custom audience options')} triggerOpen={hasAdvancedAudienceTargetingError}>
        <AdvancedAudienceTargetingSection
          formik={formik}
          audiencesIsLoading={audiencesIsLoading}
          formattedAudiences={formattedAudiences}
        />
      </Spoiler>
    </>
  )
}

export default FacebookUploadCreativeAudienceFields
